import type { FaireProductEntity } from "../../entity_types/product";

export const p_ha7v2janew: FaireProductEntity = {
  token: "p_ha7v2janew",
  type: "product",
  name: "Keracolor Clenditioner Intro Kit - Vivids",
  brandToken: "b_7efy71k58i",
  brandName: "Keracolor",
  imageUrl:
    "https://cdn.faire.com/fastly/9f2c6a20317a7bf0f20a0c569231e26482fe281e271f731508273ef632a000f4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a437c5d5f51d58c634a4257a47cabd1f5f906828307c49ef680d9d99bda6874b.jpeg",
    "https://cdn.faire.com/fastly/335cb9875c8c936e8b428105f46b43fa3f7f2b5b98937477aa05c875407b2fd9.jpeg",
    "https://cdn.faire.com/fastly/a656f09df6cd77e0d5ddc02c90da76d4904b71dd47dc97ca976e36054e7c3943.jpeg",
    "https://cdn.faire.com/fastly/86c4a611d8ce37a1181398e9eafaccea0d7b92ec15ddb317f1798153f54703b8.jpeg",
    "https://cdn.faire.com/fastly/b26dbd0557713ea8961f179b03b8f9bd70620d731886a5d7b154cc46f59cd0ed.jpeg",
    "https://cdn.faire.com/fastly/c6115d48c2578ce702d0282c5fd62a5aab468346a404ce2487476e17274be9f9.jpeg",
    "https://cdn.faire.com/fastly/f26ee1ea8b3eab255495ad8d598751d7444331065ba9056becb6e233568a760c.jpeg",
    "https://cdn.faire.com/fastly/1751d7c1fdf45038d33cf3d01653857ffa6e9d4ed4a133378331f64aec1fef8e.jpeg",
  ],
  priceDollars: 99,
  description:
    "Kit includes: \n12oz Clenditioner (2 each) \nBlue, Teal, Emerald, Hot Pink\n\nLiter Clenditioner (1 each) \nPurple, Clenditioner (no color) \n\n+ Shelf Talker Display & Tent Card!\n\n\nExperience instant semi-permanent for vivid fashion, pastel, and natural hair color with Keracolor’s Color + Clenditioner. Non-damaging & deposit-only, this clenditioner replenishes your hair while enhancing, transforming and toning your hair color. It’s built smart, adding color intensity with every use and extending color between salon trips. Now available in 21 different hues that are kind to your hair - cruelty, sulfate, paraben, gluten-free - ingredients. The Keracolor line is infused with our Keratin, combined with nourishing and rejuvenating coconut oil, shea butter, rose hip oil, jojoba oil & almond oil making your hair healthier and silkier with each use.\n\nHighlights: 3-in-1 product color, cleanse, condition\nSemi-permanent direct hair dye\nEnhance color vibrancy\nTone out unwanted color\nCustomizable color ",
  tags: [],
  msrpDollars: 198,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:54.509Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
